const SESSION_STORAGE = {
  MARKETING: "marketingCode",
};

Object.freeze([SESSION_STORAGE]);

export { SESSION_STORAGE };
